import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import r from "../../core/Collection.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import "../../libs/maquette/projection.js";
import { createProjector as i } from "../../libs/maquette/projector.js";
import { WatchUpdatingTracking as a } from "../support/WatchUpdatingTracking.js";

var c = /*#__PURE__*/function (_e) {
  _inherits(c, _e);

  var _super = _createSuper(c);

  function c() {
    var _this;

    _classCallCheck(this, c);

    _this = _super.apply(this, arguments), _this.items = new r(), _this._watchUpdatingTracking = new a(), _this._callbacks = new Map(), _this._projector = i(), _this._hiddenProjector = i();
    return _this;
  }

  _createClass(c, [{
    key: "needsRender",
    get: function get() {
      return this.items.length > 0;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      var t = document.createElement("div");
      t.className = "esri-overlay-surface", this._set("surface", t), this._hiddenSurface = document.createElement("div"), this._hiddenSurface.setAttribute("style", "visibility: hidden;"), t.appendChild(this._hiddenSurface), this._watchUpdatingTracking.addOnCollectionChange(this.items, function (t) {
        var _iterator = _createForOfIteratorHelper(t.added),
            _step;

        try {
          var _loop = function _loop() {
            var e = _step.value;

            var t = function t() {
              return e.render();
            };

            _this2._callbacks.set(e, t), _this2._projector.append(_this2.surface, t);
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(t.removed),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e2 = _step2.value;

            var _t = _this2._projector.detach(_this2._callbacks.get(_e2));

            _this2.surface.removeChild(_t.domNode), _this2._callbacks.delete(_e2);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    }
  }, {
    key: "addItem",
    value: function addItem(t) {
      this.items.add(t);
    }
  }, {
    key: "removeItem",
    value: function removeItem(t) {
      this.items.remove(t);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this3 = this;

      this.items.removeAll(), this._callbacks.forEach(function (t) {
        return _this3._projector.detach(t);
      }), this._callbacks = null, this._projector = null, this._watchUpdatingTracking.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      this._projector.renderNow();
    }
  }, {
    key: "computeBoundingRect",
    value: function computeBoundingRect(t) {
      var e = this._hiddenSurface,
          r = this._hiddenProjector;
      var o = null;

      var s = function s() {
        return o = t.render(), o;
      };

      r.append(e, s), r.renderNow();
      var i = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      };

      if (o && o.domNode) {
        var _t2 = o.domNode.getBoundingClientRect();

        i.left = _t2.left, i.top = _t2.top, i.right = _t2.right, i.bottom = _t2.bottom;
      }

      for (r.detach(s); e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      return i;
    }
  }, {
    key: "overlaps",
    value: function overlaps(t, e) {
      var r = this.computeBoundingRect(t),
          o = this.computeBoundingRect(e);
      return Math.max(r.left, o.left) <= Math.min(r.right, o.right) && Math.max(r.top, o.top) <= Math.min(r.bottom, o.bottom);
    }
  }, {
    key: "hasVisibleItems",
    get: function get() {
      return this.items.some(function (t) {
        return t.visible;
      });
    }
  }, {
    key: "renderCanvas",
    value: function renderCanvas(t) {
      if (!this.items.some(function (t) {
        return t.visible;
      })) return;
      var e = t.getContext("2d");
      e.save(), e.font = "10px ".concat(getComputedStyle(this.surface).fontFamily), this.items.forEach(function (t) {
        e.save(), t.renderCanvas(e), e.restore();
      }), e.restore();
    }
  }]);

  return c;
}(e);

t([o({
  readOnly: !0
})], c.prototype, "surface", void 0), t([o({
  readOnly: !0
})], c.prototype, "items", void 0), t([o({
  readOnly: !0
})], c.prototype, "needsRender", null), t([o({
  readOnly: !0
})], c.prototype, "_watchUpdatingTracking", void 0), t([o({
  readOnly: !0,
  aliasOf: "_watchUpdatingTracking.updating"
})], c.prototype, "updating", void 0), c = t([s("esri.views.overlay.ViewOverlay")], c);
var n = c;
export { n as default };